import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import Divider from "@mui/material/Divider";

import ExpandableButtonListItem from "@meetyoo/components/src/components/List/ExpandableButtonListItem";

const DrawerHomeContent = ({ onClickFn }) => {
  return [
    <NavLink onClick={onClickFn} key="drawer-home-navlink" style={{ color: "inherit", textDecoration: "none" }} to="/">
      <ExpandableButtonListItem title="Home" onClickHandler={onClickFn} />
    </NavLink>,
    <Divider key="drawer-home-devider" />,
  ];
};
// <ButtonListItem title="Home" icon={<HomeIcon />} />

DrawerHomeContent.proptypes = {
  onClickFn: PropTypes.func.isRequired,
};

export default DrawerHomeContent;
